// extracted by mini-css-extract-plugin
export default {"message":"_2Sra8","messageWithMarginTop":"_267Ku"};